import { render, staticRenderFns } from "./CreateCompanyValuesModal.vue?vue&type=template&id=a6d7978e&scoped=true&"
import script from "./CreateCompanyValuesModal.vue?vue&type=script&setup=true&lang=js&"
export * from "./CreateCompanyValuesModal.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./CreateCompanyValuesModal.vue?vue&type=style&index=0&id=a6d7978e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6d7978e",
  null
  
)

export default component.exports